export default __webpack_public_path__ + "1bda1339ee485967e758f57183a3ba56.png";